// Branding Configuration
// Change these values to rebrand the application for different domains

export const BRANDING = {
  // Domain and App Name
  domain: "passmloexam.com",
  appName: "Pass MLO Exam",
  appShortName: "PassMLOExam",
  
  // Meta Information
  title: "Pass MLO Exam - Practice Questions & Study Guide",
  description: "Master your MLO exam with comprehensive practice questions and detailed explanations.",
  
  // Copyright
  copyrightYear: 2026,
  copyrightOwner: "Pass MLO Exam",
  
  // Page Titles
  loginTitle: "Pass MLO Exam",
  signupTitle: "Create Pass MLO Exam Account",
  
  // Messages
  paymentRequiredMessage: "Payment required. Please purchase access to Pass MLO Exam.",
  newUserPrompt: "New to Pass MLO Exam?",
  
  // FAQ Content
  faqAppName: "Pass MLO Exam",
  faqDescription: "Full access to NMLS questions, explanations, and progress tracking in Pass MLO Exam.",
};

// Helper function to get title with section
export const getPageTitle = (section = "", category = "") => {
  const parts = [BRANDING.appName];
  if (section) parts.push(section);
  if (category) parts.push(category);
  return parts.join(" • ");
};

export default BRANDING;
